
import { Component, Vue, Prop } from 'vue-property-decorator';

import { stepInfoType } from "@/types/Application";
import PageBase from "@/components/steps/PageBase.vue";

import GetHelpForPdf from "./helpPages/GetHelpForPDF.vue"

import FormList from "./components/FormList.vue"
import RequiredDocument from "./components/RequiredDocument.vue"
import ReminderNotes from "./components/ReminderNotes.vue"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import "@/store/modules/common";
import { locationsInfoType } from '@/types/Common';
const commonState = namespace("Common");

@Component({
    components:{
        PageBase,
        GetHelpForPdf,
        FormList,
        RequiredDocument,
        ReminderNotes
    }
})

export default class ReviewAndPrint extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @commonState.State
    public locationsInfo!: locationsInfoType[];

    @applicationState.State
    public types!: string[];    

    error= "";
    currentStep =0;
    currentPage =0;
   
    includesPO = false;    

    showGetHelpForPDF = false;
    applicantLocation = {} as locationsInfoType;
    filingLocation = {} as locationsInfoType;      

    mounted(){

        this.includesPO = this.types.includes("Protection Order") || this.types.includes("New Protection Order") || this.types.includes("Change Protection Order") || this.types.includes("Terminate Protection Order")

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        let progress = this.$store.state.Application.steps[this.currentStep].pages[this.currentPage].progress
        
        if(progress==0) progress=50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);

        let location = this.$store.state.Application.applicationLocation
        if(!location) location = this.$store.state.Common.userLocation
        
        this.applicantLocation = this.locationsInfo.filter(loc => {if (loc.name == location) return true})[0]
           
        if (this.applicantLocation["filingLocation"]){
            this.filingLocation = this.locationsInfo.filter(loc => {if (loc.id == this.applicantLocation["filingLocation"]) return true})[0]
        } else {
            this.filingLocation = this.applicantLocation;
        }

    }  
    
    public downloaded(){
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, false);
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage()     
    }

    public navigateToGuide(){
        Vue.filter('scrollToLocation')("pdf-guide");
    }  

}
